function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import './ToggleSwitch.css';
import cs from 'classnames';
import whitelistProps from '../../utils/whitelistProps';
import noop from '../../utils/noop';
import I18n from '../../I18n/I18n/I18n';
import withInputContainer from '../withInputContainer/withInputContainer';
import { useContext } from 'react';
import ThemeContext from '../../ThemeContext/ThemeContext';
var whitelist = whitelistProps();

/**
 * Toggle switch. Unlike form inputs (checkbox or radio), toggle switches should
 * initiate an immediate action (versus waiting until the entire form submits).
 * If you find yourself wanting to do the opposite, consider using a checkbox
 * or radio input instead. This implementation is based off [Heydon Pickering's]
 * (https://inclusive-components.design/toggle-button/#theswitchrole).
 * @name ToggleSwitch
 */
export function ToggleSwitch(_ref) {
  var onLabel = _ref.onLabel,
    offLabel = _ref.offLabel,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'toggle' : _ref$type,
    auto = _ref.auto,
    className = _ref.className,
    label = _ref.label,
    descriptionId = _ref.descriptionId,
    errorId = _ref.errorId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    id = _ref.id,
    style = _ref.style,
    checked = _ref.checked,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    attrs = _objectWithoutProperties(_ref, ["onLabel", "offLabel", "type", "auto", "className", "label", "descriptionId", "errorId", "size", "loading", "id", "style", "checked", "disabled", "readonly", "onBlur", "onClick", "onFocus"]);
  var theme = useContext(ThemeContext);
  var contents = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "assistive-text"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: label
  }), ":"), checked ? /*#__PURE__*/React.createElement(I18n, {
    i18n: onLabel
  }) : /*#__PURE__*/React.createElement(I18n, {
    i18n: offLabel
  }));
  if (disabled) {
    return /*#__PURE__*/React.createElement("span", {
      style: {
        paddingTop: '0.575ex'
      }
    }, contents);
  } else {
    return /*#__PURE__*/React.createElement("button", Object.assign({
      id: id,
      type: "button",
      role: "switch",
      className: cs("_dm-toggle-btn", "_dm-input _dm-input--".concat(size), "_dm-input--".concat(type, " _dm-input--").concat(type, "--").concat(size), "_dm-input--".concat(theme, "--").concat(type, " _dm-input--").concat(theme, "--").concat(type, "--").concat(size), "auto-".concat(type, "-input"), _defineProperty(_defineProperty({
        '_dm-toggle-btn--readonly': readonly,
        '_dm-toggle-btn--on': checked,
        '_dm-toggle-btn--off': !checked,
        '_dm-toggle-btn--loading': loading
      }, auto, auto), className, className))
      // use !! conversion so no matter what `aria-checked` gets rendered
      ,
      "aria-checked": !!checked,
      "aria-readonly": readonly,
      "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
      "aria-busy": loading,
      "aria-live": "polite",
      "aria-atomic": "true",
      onClick: readonly ? noop : onClick
    }, whitelist(attrs)), contents);
  }
}
export default withInputContainer({
  type: 'toggle',
  'aria-hidden': true
})(ToggleSwitch);